import React from "react";
import "./Boutique.css";

import { Typography } from "@material-ui/core";

// TODO

function Boutique() {
  return (
    <div className="Boutique">
      <Typography variant="h1">Boutique</Typography>
    </div>
  );
}

export default Boutique;
